import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Select} from "antd";
import "./sortWay.css";

/**
 * creat by xcc
 * @description 排序方式
 */
const {Option} = Select
export default class SortWay extends Component {
    static propTypes = {
        onClick: PropTypes.func,
        options: PropTypes.array,
        defaultValue: PropTypes.string,
        width: PropTypes.number
    };
    static defaultProps = {
        onClick: () => {
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            params: {
                order: props.defaultValue,
                sort: -1
            }
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    reset() {
        this.setState({
            params: {
                order: this.props.defaultValue,
                sort: -1
            }
        })
    }

    getData() {
        return{...this.state.params};
    }

    onChange(key, val) {
        const {refreshList} = this.props;
        this.state.params[key] = val;
        this.setState({}, () => {refreshList()})
    }

    render() {
        const {sort} = this.state.params;
        const { listData, options, width = 150, isShow } = this.props;
        return (
            <div style={{display: isShow ? "flex" : "none", alignItems: "center"}}>
                <div>排序方式：</div>
                <div>
                    <Select placeholder={"请选择"} defaultValue={this.state.params.order}
                            value={this.state.params.order || undefined} style={{width: `${width}px`}} onChange={(val) => {
                        this.onChange("order", val)
                    }}>
                        {
                            options.map((item) => {
                                return <Option key={item.key} value={item.value}>{item.label}</Option>
                            })
                        }
                    </Select>
                </div>
                <div className="arrow" style={{cursor: "pointer"}} onClick={()=>{this.onChange("sort",sort === 1? -1 : 1)}}>
                    <div  style={{borderColor: sort === 1 ? "transparent transparent #0050b3" : "transparent transparent #aaa"}} className="triangle-up"></div>
                    <div  style={{borderColor: sort === -1 ? "transparent transparent #0050b3" : "transparent transparent #aaa"}} className="triangle-down"></div>
                </div>
                {listData && <div style={{marginLeft: 10}}>已检索到 <span style={{fontWeight: "bold"}}>{listData.length}</span> 条数据
                </div>}
            </div>
        )
    }
}